module.exports = __webpack_public_path__ + "img/avatar.7d7eb65a.png";